import type { IduraMode, IduraSettingsResponse } from "@repo/shared/types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import * as iduraApi from "@/lib/api/idura";

export function useIduraSettings() {
  const { data, error, isLoading } = useQuery({
    queryKey: ["idura-settings"],
    queryFn: () => iduraApi.getSettings(),
  });
  const queryClient = useQueryClient();
  const mutate = () => queryClient.invalidateQueries({ queryKey: ["idura-settings"] });
  return { settings: data ?? null, error, isLoading, mutate };
}

/**
 * Read-only access to the tenant's Idura mode for surfaces outside the settings
 * page (e.g. the signing UI deciding whether eID is available). The GET endpoint
 * is session-gated only, so any authenticated user can resolve the mode.
 */
export function useIduraMode(): { iduraMode: IduraMode | null; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["idura-settings"],
    queryFn: () => iduraApi.getSettings(),
    select: (d) => d.iduraMode,
  });
  return { iduraMode: data ?? null, isLoading };
}

export type { IduraSettingsResponse };
